import styled from 'styled-components/macro';
import { transparentize } from 'polished';

export const SearchFieldContainer = styled.div.attrs(({ className }) => ({
  className,
}))`
  width: 100%;
  max-width: 52rem;
  border-radius: 1.2rem;
  border: 1px solid ${(props) => props.theme.grey.light};
  height: 6rem;
  transition: 0.2s;
  position: relative;
  box-shadow: 0 0.5rem 2rem 0
    ${(props) => transparentize(0.88, props.theme.fontColor.primary)};

  .close-icon {
    position: absolute;
    right: 15px;
    font-size: 30px;
    top: 50%;
    transform: translate(0, -50%);
    color: ${(props) => props.theme.grey.dark};
    padding: 0 10px;
  }
  input {
    padding: 2rem 5rem;
    border: 0;
    height: 100%;
    width: 100%;
    border-radius: 1.2rem;
    font-size: 1.4rem;
    color: ${(props) => props.theme.fontColor.primary};
    font-weight: 700;
    &::-webkit-input-placeholder {
      /* Chrome/Opera/Safari */
      color: ${(props) => props.theme.grey.primary};
      font-size: 1.4rem;
      font-weight: 400;
    }
    &::-moz-placeholder {
      /* Firefox 19+ */
      color: ${(props) => props.theme.grey.primary};
      font-size: 1.4rem;
      font-weight: 400;
    }
    &:-ms-input-placeholder {
      /* IE 10+ */
      color: ${(props) => props.theme.grey.primary};
      font-size: 1.4rem;
      font-weight: 400;
    }
    &:-moz-placeholder {
      /* Firefox 18- */
      color: $grey;
      font-size: 1.4rem;
      font-weight: 400;
    }
    &:hover,
    &:focus {
      outline: none;
      box-shadow: none;
    }
  }
  &:hover,
  &:focus,
  &.active {
    border-color: ${(props) => props.theme.accent};
    box-shadow: 0 0.5rem 2rem 0
      ${(props) => transparentize(0.88, props.theme.accent)};
  }
  img {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 1.6rem;
    width: 2rem;
  }
`;
